"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultCurrencyConfig = void 0;
var currency_format_1 = require("./currency-format");
var number_1 = require("./number");
/**
 * The default currency configuration.
 * Example: $123,456.78
 */
exports.defaultCurrencyConfig = __assign(__assign({}, number_1.defaultNumberConfig), { symbol: '$', format: currency_format_1.defaultCurrencyFormat });
//# sourceMappingURL=currency.js.map